export default __webpack_public_path__ + "5065530d6bfc866b731c8bcd1ea96ec2.png";